import ImageWithDisplayName from "@/common/components/ImageWithDisplayName";
import { formatDateTime } from "@/common/utils/formatters";
import { MaintenanceWorkflowValidDiagnosticEntry } from "@/features/privateCompanies/types/maintenance/workflows/maintenanceWorkflowValidDiagnosticEntries.type";
import { Building2Icon } from "lucide-react";

export class MaintenanceWorkflowValidDiagnosticEntriesTransformer {

  static optionsTransformer() {
    return (diagnosticEntries: MaintenanceWorkflowValidDiagnosticEntry[]) => {
      return diagnosticEntries.map((diagnosticEntry) => {
        const establishmentFantasyName = diagnosticEntry.forwarding?.establishment?.general_information?.fantasy_name || '--';
        const establishmentCompanyLogo = diagnosticEntry.forwarding?.establishment?.general_information?.company_logo?.url;
        const diagnosticEntryFormattedId = diagnosticEntry.id?.split('-')?.[0]?.toUpperCase() || '--';
        const completedAtFormatted = diagnosticEntry.completed_at ? formatDateTime(new Date(diagnosticEntry.completed_at)) : null;

        return {
          value: diagnosticEntry.id,
          label: (
            <div className="flex items-center gap-1">
              <ImageWithDisplayName
                placeholderIcon={Building2Icon}
                imageUrl={establishmentCompanyLogo}
                displayName={`${establishmentFantasyName} - ${diagnosticEntryFormattedId}`}
              />

              {completedAtFormatted && (
                <span className="text-white-400 italic">
                  ({completedAtFormatted})
                </span>
              )}
            </div>
          ),
          filter: `${establishmentFantasyName} - ${diagnosticEntryFormattedId} ${completedAtFormatted ? `(${completedAtFormatted})` : ''}`,
        };
      });
    }
  }

}
